import { Link, useLocation } from "react-router-dom";
import { Home, FileText, User, ScrollText, Zap } from "lucide-react";
import { cn } from "@/frontend/lib/utils";

const navItems = [
  { label: "Dashboard", href: "/student/dashboard", icon: Home },
  { label: "My Contract", href: "/student/contract", icon: FileText },
  { label: "Energy", href: "/student/energy", icon: Zap },
  { label: "Regulations", href: "/student/regulations", icon: ScrollText },
  { label: "Profile", href: "/student/profile", icon: User },
];

export const StudentNavigation = () => {
  const location = useLocation();

  return (
    <>
      {/* Desktop: horizontal nav (rendered inside header, takes up center space) */}
      <nav className="hidden md:flex flex-1 justify-center gap-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors rounded-md",
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              )}
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* Mobile: fixed bottom tab bar */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border">
        <div className="grid grid-cols-5 h-16">
          {navItems.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  "flex flex-col items-center justify-center gap-0.5 transition-colors",
                  isActive
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                <item.icon className={cn("h-5 w-5", isActive && "fill-primary/20")} />
                <span className="text-[10px] font-medium leading-tight">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
};
